var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: { id: "new-transaction-modal", active: _vm.displayModal },
      on: { close: _vm.close },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("vacation-modal", {
        ref: "vacationModal",
        attrs: { "can-edit": false },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingData,
              expression: "!isLoadingData",
            },
          ],
          staticClass: "modal-frame",
        },
        [
          _c(
            "div",
            { staticClass: "modal-wrapper" },
            [
              _c(
                "shadow-scroll-container",
                {
                  ref: "track",
                  staticClass: "modal-track",
                  attrs: { "with-top-scroller": true },
                },
                [
                  _c("div", { staticClass: "modal-frame__header" }, [
                    _c("h2", { staticClass: "modal-frame__title" }, [
                      _vm._v("Новая проводка"),
                    ]),
                  ]),
                  _vm.recordData
                    ? _c(
                        "div",
                        { staticClass: "calculation-sheet__filial" },
                        [
                          _c("svg-icon", {
                            staticClass: "calculation-sheet__filial-icon",
                            attrs: { name: "place" },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.recordData.filial.value) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isEditableMode
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-auto" },
                          [
                            _c("c-switcher", {
                              staticClass: "h-switcher",
                              attrs: {
                                type: "group",
                                items: _vm.transactionTypes.types,
                              },
                              model: {
                                value: _vm.transactionTypes.selectedType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.transactionTypes,
                                    "selectedType",
                                    $$v
                                  )
                                },
                                expression: "transactionTypes.selectedType",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isEditableMode
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c("div", { staticClass: "modal-frame__worker" }, [
                              _c("img", {
                                staticClass: "modal-frame__worker-photo",
                                attrs: {
                                  src: `${
                                    _vm.worker.photo
                                      ? _vm.worker.photo
                                      : "/redesign/img/userpic.svg"
                                  }`,
                                  alt: "",
                                  width: "34",
                                  height: "34",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "modal-frame__worker-text" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "modal-frame__worker-name" },
                                    [_vm._v(_vm._s(_vm.worker.name))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modal-frame__worker-posts",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.recordData.post_name.value)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.isEditableMode
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "modal-frame__transaction-type" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-frame__transaction-type-name",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color:
                                            _vm.transactionTypes.selectedItem
                                              .type === "withdraw"
                                              ? "#ff238d"
                                              : "#12c971",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transactionTypes.selectedItem
                                              .short_name
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.transactionTypes.selectedItem
                                            .label
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-frame__transaction-type-description",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.transactionTypes.selectedItem
                                          .description
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.isEditableMode
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c("c-select-2", {
                              staticClass: "modal-frame__transaction-type",
                              attrs: {
                                type: "select",
                                "floating-label": "Тип проводки",
                                clearable: true,
                                searchable: true,
                                items: _vm.transactionTypes.items,
                                useCustomColors: true,
                                required:
                                  _vm.isSubmitted && _vm.transactionTypesError,
                                "required-message":
                                  _vm.isSubmitted && _vm.transactionTypesError,
                                "required-mark": true,
                              },
                              model: {
                                value: _vm.transactionTypes.selectedItem,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.transactionTypes,
                                    "selectedItem",
                                    $$v
                                  )
                                },
                                expression: "transactionTypes.selectedItem",
                              },
                            }),
                            _vm.transactionTypes.selectedItem &&
                            _vm.transactionTypes.selectedItem.description
                              ? _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover click blur",
                                        boundary: "window",
                                        content: `
                  <div style='font-size: 11px; line-height: 120%; color: ${
                    this.transactionTypes.selectedItem.type === "deposit"
                      ? "#12C971;"
                      : "#FF238D;"
                  }'>
                    ${
                      this.transactionTypes.selectedItem.type === "deposit"
                        ? "Начисления"
                        : "Списания"
                    }
                  </div>
                  <div style='font-size: 13px; font-weight: 700'>${
                    this.transactionTypes.selectedItem.label
                  }</div>
                  <div style='margin: 5px 0 15px;'>${
                    this.transactionTypes.selectedItem.description
                  }</div>
                  <div style='margin: 5px 0 0;'>${
                    this.selectedTypeConditions
                  }</div>
                  <button style='margin-top: 15px;' type='button' class='c-button close-popover c-button-ok'>
                    <span class='c-button-label'>Ок</span>
                  </button>
                `,
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                container: '#app',\n                trigger: 'hover click blur',\n                boundary: 'window',\n                content: \n                `\n                  <div style='font-size: 11px; line-height: 120%; color: ${this.transactionTypes.selectedItem.type === 'deposit' ? '#12C971;' : '#FF238D;'}'>\n                    ${this.transactionTypes.selectedItem.type === 'deposit' ? 'Начисления' : 'Списания'}\n                  </div>\n                  <div style='font-size: 13px; font-weight: 700'>${this.transactionTypes.selectedItem.label}</div>\n                  <div style='margin: 5px 0 15px;'>${this.transactionTypes.selectedItem.description}</div>\n                  <div style='margin: 5px 0 0;'>${this.selectedTypeConditions}</div>\n                  <button style='margin-top: 15px;' type='button' class='c-button close-popover c-button-ok'>\n                    <span class='c-button-label'>Ок</span>\n                  </button>\n                `,\n                placement: 'top',\n              }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  staticClass:
                                    "form-group__item-description form-group__item-description--desktop",
                                  attrs: { size: "iconic", icon: "info-new" },
                                })
                              : _vm._e(),
                            _vm.transactionTypes.selectedItem &&
                            _vm.transactionTypes.selectedItem.description
                              ? _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "click blur",
                                        boundary: "window",
                                        content: `
                  <div style='font-size: 11px; line-height: 120%; color: ${
                    this.transactionTypes.selectedItem.type === "deposit"
                      ? "#12C971;"
                      : "#FF238D;"
                  }'>
                    ${
                      this.transactionTypes.selectedItem.type === "deposit"
                        ? "Начисления"
                        : "Списания"
                    }
                  </div>
                  <div style='font-size: 13px; font-weight: 700'>${
                    this.transactionTypes.selectedItem.label
                  }</div>
                  <div style='margin: 5px 0 15px;'>${
                    this.transactionTypes.selectedItem.description
                  }</div>
                  <div style='margin: 5px 0 15px;'>${
                    this.selectedTypeConditions
                  }</div>
                  <button type='button' class='c-button close-popover'>
                    <span class='c-button-label'>Ок</span>
                  </button>
                `,
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: \n                `\n                  <div style='font-size: 11px; line-height: 120%; color: ${this.transactionTypes.selectedItem.type === 'deposit' ? '#12C971;' : '#FF238D;'}'>\n                    ${this.transactionTypes.selectedItem.type === 'deposit' ? 'Начисления' : 'Списания'}\n                  </div>\n                  <div style='font-size: 13px; font-weight: 700'>${this.transactionTypes.selectedItem.label}</div>\n                  <div style='margin: 5px 0 15px;'>${this.transactionTypes.selectedItem.description}</div>\n                  <div style='margin: 5px 0 15px;'>${this.selectedTypeConditions}</div>\n                  <button type='button' class='c-button close-popover'>\n                    <span class='c-button-label'>Ок</span>\n                  </button>\n                `,\n                placement: 'top',\n              }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  staticClass:
                                    "form-group__item-description form-group__item-description--mobile",
                                  attrs: {
                                    icon: "info-new",
                                    label: "Показать описание",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  !_vm.isEditableMode
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c("c-select-2", {
                              attrs: {
                                type: "select",
                                "floating-label": "Сотрудник",
                                clearable: true,
                                searchable: true,
                                items: _vm.workersList.defaultItems,
                                required:
                                  _vm.isSubmitted && _vm.selectedEmployeeError,
                                "required-message":
                                  _vm.isSubmitted && _vm.selectedEmployeeError,
                                "required-mark": true,
                              },
                              model: {
                                value: _vm.workersList.selectedEmployee,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.workersList,
                                    "selectedEmployee",
                                    $$v
                                  )
                                },
                                expression: "workersList.selectedEmployee",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.balances.worker_id
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group__item-balances" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group__item-balances-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-header",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group__item-balances-item-number",
                                            class: {
                                              positive:
                                                _vm.balances.personal_amount >
                                                0,
                                              negative:
                                                _vm.balances.personal_amount <
                                                0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.balances.personal_amount
                                                  )
                                                ) +
                                                " ฿ "
                                            ),
                                          ]
                                        ),
                                        _c("c-button", {
                                          directives: [
                                            {
                                              name: "b-popover",
                                              rawName: "v-b-popover.html",
                                              value: {
                                                container: "#app",
                                                trigger: "hover click blur",
                                                boundary: "window",
                                                content:
                                                  this.filialsWithBalances,
                                                placement: "top",
                                              },
                                              expression:
                                                "{\n                      container: '#app',\n                      trigger: 'hover click blur',\n                      boundary: 'window',\n                      content: this.filialsWithBalances,\n                      placement: 'top',\n                    }",
                                              modifiers: { html: true },
                                            },
                                          ],
                                          staticClass:
                                            "form-group__balances-description",
                                          attrs: {
                                            size: "iconic",
                                            icon: "info-new",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-name",
                                      },
                                      [_vm._v("Личный счет")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group__item-balances-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-header",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group__item-balances-item-number",
                                            class: {
                                              positive:
                                                _vm.balances.deposit_amount > 0,
                                              negative:
                                                _vm.balances.deposit_amount < 0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.balances.deposit_amount
                                                  )
                                                ) +
                                                " ฿ "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-name",
                                      },
                                      [_vm._v("Депозит")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group__item-balances-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-header",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group__item-balances-item-number",
                                            class: {
                                              positive:
                                                _vm.balances
                                                  .accountable_amount > 0,
                                              negative:
                                                _vm.balances
                                                  .accountable_amount < 0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.balances
                                                      .accountable_amount
                                                  )
                                                ) +
                                                " ฿ "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group__item-balances-item-name",
                                      },
                                      [_vm._v("Подотчет")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.transactionTypeWithoutReason
                    ? _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            { staticClass: "col col-12 col-md-10 col-xl-6" },
                            [
                              _c("c-input", {
                                staticClass: "modal-frame__transaction-type",
                                class: {
                                  "is-invalid":
                                    _vm.isSubmitted &&
                                    _vm.transactionReasonsError,
                                },
                                attrs: {
                                  type: "select",
                                  "floating-label": _vm.transactionReason,
                                  clearable: true,
                                  searchable: true,
                                  items: _vm.transactionReasons.items,
                                  groups: _vm.transactionReasons.groups,
                                  useCustomColors: true,
                                  required:
                                    _vm.isSubmitted &&
                                    _vm.transactionReasonsError,
                                  "required-condition":
                                    _vm.isSubmitted &&
                                    _vm.transactionReasonsError,
                                  "required-mark": true,
                                  disabled:
                                    !_vm.transactionTypes.selectedItem ||
                                    (!_vm.posts.selectedPost &&
                                      (_vm.transactionTypes.selectedItem
                                        .short_name === "ШТРФ" ||
                                        _vm.transactionTypes.selectedItem
                                          .short_name === "ПРЕМ")),
                                },
                                model: {
                                  value: _vm.transactionReasons.selectedReason,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.transactionReasons,
                                      "selectedReason",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transactionReasons.selectedReason",
                                },
                              }),
                              _vm.transactionReasons.selectedReason &&
                              (_vm.transactionReasons.selectedReason
                                .description ||
                                _vm.transactionReasons.selectedReason
                                  .subLabel) &&
                              _vm.transactionTypes.selectedItem.short_name !==
                                "ШТРФ" &&
                              _vm.transactionTypes.selectedItem.short_name !==
                                "ПРЕМ"
                                ? _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "click blur",
                                          boundary: "window",
                                          content:
                                            this.transactionReasons
                                              .selectedReason.description ||
                                            this.transactionReasons
                                              .selectedReason.subLabel,
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: this.transactionReasons.selectedReason.description || this.transactionReasons.selectedReason.subLabel,\n                placement: 'top',\n              }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "form-group__item-description form-group__item-description--desktop",
                                    attrs: { size: "iconic", icon: "info-new" },
                                  })
                                : _vm._e(),
                              _vm.transactionReasons.selectedReason &&
                              (_vm.transactionReasons.selectedReason
                                .description ||
                                _vm.transactionReasons.selectedReason
                                  .subLabel) &&
                              _vm.transactionTypes.selectedItem.short_name !==
                                "ШТРФ" &&
                              _vm.transactionTypes.selectedItem.short_name !==
                                "ПРЕМ"
                                ? _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "click blur",
                                          boundary: "window",
                                          content:
                                            this.transactionReasons
                                              .selectedReason.description ||
                                            this.transactionReasons
                                              .selectedReason.subLabel,
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: this.transactionReasons.selectedReason.description || this.transactionReasons.selectedReason.subLabel,\n                placement: 'top',\n              }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "form-group__item-description form-group__item-description--mobile",
                                    attrs: {
                                      icon: "info-new",
                                      label: "Показать описание",
                                    },
                                  })
                                : _vm._e(),
                              _vm.transactionReasons.selectedReason &&
                              _vm.transactionReasons.selectedReason.file &&
                              (_vm.transactionTypes.selectedItem.short_name ===
                                "ОТП" ||
                                _vm.transactionTypes.selectedItem.short_name ===
                                  "БЛН")
                                ? _c("c-button", {
                                    staticClass:
                                      "form-group__item-description form-group__item-description--desktop",
                                    attrs: { size: "iconic", icon: "info-new" },
                                    on: { click: _vm.openVacation },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.transactionTypes.selectedItem.short_name ===
                          "ШТРФ"
                            ? _c("show-description", {
                                staticClass: "show-description",
                                attrs: {
                                  value:
                                    _vm.transactionReasons.selectedReason &&
                                    _vm.transactionReasons.selectedReason.value,
                                  list: _vm.fineDescriptions,
                                  type: "mini",
                                },
                              })
                            : _vm._e(),
                          _vm.transactionTypes.selectedItem.short_name ===
                          "ПРЕМ"
                            ? _c("show-description", {
                                staticClass: "show-description",
                                attrs: {
                                  value:
                                    _vm.transactionReasons.selectedReason &&
                                    _vm.transactionReasons.selectedReason.value,
                                  list: _vm.bonusDescriptions,
                                  type: "mini",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "row row-sum" }, [
                    _c(
                      "div",
                      { staticClass: "col col-6 col-md-3 col-xl-2" },
                      [
                        _c("c-input", {
                          attrs: {
                            type: "price-number",
                            label: "Сумма, ฿",
                            placeholder: "0",
                            "max-length": 12,
                            clearable: true,
                            required:
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "required-message":
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "input-text-condition":
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.transactionAmount,
                            callback: function ($$v) {
                              _vm.transactionAmount = $$v
                            },
                            expression: "transactionAmount",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col col-6 col-md-3 col-xl-2" },
                      [
                        _c("c-input", {
                          ref: "dateInput",
                          attrs: {
                            label: "Дата учетная",
                            editable: true,
                            clearable: true,
                            type: "date",
                            format: "DD.MM.YYYY, dddd",
                            icon: "calendar",
                            placeholder: "00.00.0000",
                            required:
                              _vm.isSubmitted && _vm.transactionDate.error,
                            "required-message":
                              _vm.isSubmitted && _vm.transactionDate.error,
                            "required-mark": true,
                            "icon-right": true,
                          },
                          on: { invalidDate: _vm.sendErrorDateMessage },
                          model: {
                            value: _vm.transactionDate.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.transactionDate, "value", $$v)
                            },
                            expression: "transactionDate.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-10 col-xl-6" },
                      [
                        _c("c-select-2", {
                          attrs: {
                            type: "select",
                            "floating-label": "Кто принял решение",
                            clearable: true,
                            searchable: true,
                            items: _vm.workersList.items,
                          },
                          model: {
                            value: _vm.workersList.selectedWorker,
                            callback: function ($$v) {
                              _vm.$set(_vm.workersList, "selectedWorker", $$v)
                            },
                            expression: "workersList.selectedWorker",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-10 col-xl-6" },
                      [
                        _c("c-select-2", {
                          staticClass: "modal-frame__transaction-type",
                          attrs: {
                            type: "select",
                            "floating-label": "Юр. лицо",
                            clearable: true,
                            searchable: true,
                            items: _vm.companies.items,
                            useCustomColors: true,
                            required: _vm.isSubmitted && _vm.companiesError,
                            "required-message":
                              _vm.isSubmitted && _vm.companiesError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.companies.selectedCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.companies, "selectedCompany", $$v)
                            },
                            expression: "companies.selectedCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.transactionTypeIsZp
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-12 col-md-10 col-xl-6" },
                          [
                            _c("c-select-2", {
                              attrs: {
                                type: "select",
                                "floating-label": "Источник д/с",
                                clearable: true,
                                searchable: true,
                                items: _vm.moneySourcesListFiltered,
                                required:
                                  _vm.isSubmitted &&
                                  _vm.selectedMoneySourceError,
                                "required-message":
                                  _vm.isSubmitted &&
                                  _vm.selectedMoneySourceError,
                                "required-mark": true,
                              },
                              model: {
                                value: _vm.moneySourcesList.selectedMoneySource,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.moneySourcesList,
                                    "selectedMoneySource",
                                    $$v
                                  )
                                },
                                expression:
                                  "moneySourcesList.selectedMoneySource",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-10 col-xl-6" },
                      [
                        _c("c-input", {
                          ref: "comment",
                          attrs: {
                            type: "textarea",
                            "floating-label": "Комментарий",
                            clearable: true,
                            "max-length": "255",
                          },
                          model: {
                            value: _vm.comment,
                            callback: function ($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "modal-frame__actions" },
                    [
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: { label: "Отменить", size: "large" },
                        on: { click: _vm.close },
                      }),
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: {
                          label: "Сохранить",
                          size: "large",
                          color: "primary",
                          disabled: _vm.submitIsDisabled,
                        },
                        on: { click: _vm.submit },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "modal-actions" },
            [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: { label: "Сохранить", color: "primary", size: "large" },
                on: { click: _vm.submit },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.isLoadingData
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoadingData,
              height: "400",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }